import Loader from "components/shared/loader";
import { sortedPoints } from "helpers/bidpoint";
import { groupedCarRoutes } from "helpers/map";
import { paths } from "helpers/paths";
import { ymEvent } from "helpers/system";
import { UmamiManager } from "lib/umami";
import policy from "policies";
import React, { useEffect, useMemo, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Link } from "react-router-dom";
import { getTripPlanning } from "sources/tripPlanning";
import CurrentBid from "./currentBid";
import RouteMap from "./map";
import NearBids from "./nearBids";

export default function ExpandedRoute(props) {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState();
    const [currentBid, setCurrentBid] = useState();
    const [compoundBids, setCompoundBids] = useState();

    const { car, bidId } = props.data;
    const canEditPlanning = !policy("user", { user: { roles: props.roles } }).isOnlyExtendedViewer();

    const carRoutes = useMemo(() => groupedCarRoutes(data?.currentBid?.carRoutes), [data]);

    useEffect(() => {
        UmamiManager.track("RouteAddressNameClicked");
        ymEvent("TripPlanningRouteDetailsUsed");

        if (bidId) {
            getTripPlanning(bidId, car.id).then((res) => {
                setData(res);
                setCurrentBid(res.currentBid);
                setCompoundBids(res.compoundBids);
                setLoading(false);
            });
        }
    }, []);
    if (!bidId) {
        return (
            <div className="p-expanded p-expanded--route">
                <div />
                <div className="p-expanded__card-map place-content-center">Нет информации о заявке грузовика</div>
                <div />
            </div>
        );
    }
    if (loading) {
        return (
            <div className="p-expanded p-expanded--route">
                <Loader />
            </div>
        );
    }
    const { route, bidPoints, lastCarLocation, itemChangePoints, estimation } = currentBid ?? {};

    const mapData = {
        currentBid: bidId,
        route,
        carId: car?.id,
        car,
        itemChangePoints,
        bidPoints: sortedPoints(bidPoints),
        carRoutes,
        lastCarLocation,
        estimation,
    };

    const changeCurrentBid = (item) => {
        ymEvent("TripPlanningRouteDetailsUsed");
        setCompoundBids((items) => items.map((bid) => (bid.id === item.id ? currentBid : bid)));
        setLoading(true);
        setCurrentBid(undefined);
        setTimeout(() => {
            setLoading(false);
            setCurrentBid(item);
        }, 200);
    };

    return (
        <div className="p-expanded p-expanded--route">
            <div className="p-expanded__card">
                <Scrollbars>
                    <div className="p-expanded--pr-12">
                        <div className="p-expanded__card-header">Маршрут</div>
                        <CurrentBid
                            currentBid={currentBid}
                            compoundBids={compoundBids}
                            changeCurrentBid={changeCurrentBid}
                            modal={props.modal}
                            canEditPlanning={canEditPlanning}
                        />
                    </div>
                </Scrollbars>
            </div>
            <div className="p-expanded__card-map">
                {currentBid && (
                    <RouteMap
                        withoutViewportCheck
                        className="p-expanded__map map"
                        currentBid={currentBid}
                        bidId={bidId}
                        data={mapData}
                    />
                )}
            </div>
            <div className="p-expanded__card">
                <Scrollbars>
                    <div className="p-expanded--pr-12">
                        <NearBids title="Последние рейсы" data={data?.completedBids} />
                        <NearBids title="Запланированные рейсы" data={data?.plannedBids} />
                        {canEditPlanning && !props.organization.distributedBidRequired && (
                            <div className="d-flex justify-content-end">
                                <Link
                                    to={car?.id ? `${paths.bidNew}?carId=${car.id}` : paths.bidNew}
                                    target="_blank"
                                    className="planning-btn planning-btn--brand"
                                    onClick={() => ymEvent("TripPlanningCreateBidClicked")}
                                >
                                    Создать заявку
                                </Link>
                            </div>
                        )}
                    </div>
                </Scrollbars>
            </div>
        </div>
    );
}
